<template>
        <div id='sqbm'>
              <NavTop title='最美女神/男神蜕变营活动-结营'/>
              <div class='content'>
                <img src="http://www.cnihz.cn/static/img/mltb.jpg" class='sqimg'/>
              </div> 
              <div class="title-row">请上传日常素颜肌肤照片2张</div>
              <div class="imgrow">
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img1==''?undefined:img1" :preview-image='false' image-fit="cover" name='img_1'/>
                  <span>照片1</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img2==''?undefined:img2" :preview-image='false' image-fit="cover" name='img_2'/>
                  <span>照片2</span>
                 </div>
              </div>
              <div class="title-row">请上传日常全身或者半身生活照片2张</div>
              <div class="imgrow">
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img3==''?undefined:img3" :preview-image='false' image-fit="cover" name='img_3'/>
                  <span>照片1</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img4==''?undefined:img4" :preview-image='false' image-fit="cover" name='img_4'/>
                  <span>照片2</span>
                 </div>
              </div>
              <div class="btnrow">
                  <div class="sumitbtn" @click="doBm">
                      确认结束本次活动
                  </div>
              </div>
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { NoticeBar, Uploader} from 'vant'
import {put} from '@/api'
export default {
  data(){
      return{
         img1:'',
         img2:'',
         img3:'',
         img4:'',
         bminfo:{},
         processing:false
      }
  },  
  name: 'sporder2bm_end',
  created(){
     this.getList()
  },
  methods:{
     getList(){
        this.$post("/mltb/getSporder2_endinfo").then((data)=>{
               if(data.result.success){
                  this.bminfo=data.result.info
               }else{
                 this.$toast(data.result.info)
                 setTimeout(()=>{this.$go("/my")},1000)
               }
           }) 
     },
     doBm(){
        if(this.processing){
           this.$toast("请等待提交完成");return false;
        }
        if(this.img1==''|| this.img1==undefined){
            this.$toast("请上传日常素颜肌肤照片1");return false;
        }
        if(this.img2==''|| this.img2==undefined){
            this.$toast("请上传日常素颜肌肤照片2");return false;
        }
        if(this.img3==''|| this.img3==undefined){
            this.$toast("请上传日常全身或者半身生活照片1");return false;
        }
        if(this.img4==''|| this.img4==undefined){
            this.$toast("请上传日常全身或者半身生活照片2");return false;
        }
        this.bminfo["img1"]=this.img1
        this.bminfo["img2"]=this.img2
        this.bminfo["img3"]=this.img3
        this.bminfo["img4"]=this.img4
        this.processing=true
        this.$post("/mltb/saveSporder2_end",{bminfo:this.bminfo}).then((data)=>{
           this.processing=false
           if(data.result.success){
              this.$toast(data.result.info)
              this.getList()
           }else{
              this.$toast(data.result.info)
           }
        })
     },
     afterRead(file,info) { 
      let name=info.name   
      let tag=name.split("_")
      let index=tag[1]
      const uploadImgFile=file.file
      put("/uploader/headImg",{type:'idcard',file:uploadImgFile}).then((data)=>{
           if(data.result.success){
               this['img'+index]=data.result.info.url 
           }
      })
    }
  },
  components:{
      NavTop,
      [NoticeBar.name]:NoticeBar,
      [Uploader.name]:Uploader
  }
}
</script>
<style scoped>
#sqbm{background-color:#fff;min-height: 100vh;padding-bottom: 0.5rem;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;width:100%;}
.sqimg{width:100%;display: block;}
::v-deep .fixcon{margin-bottom: 0!important;}
.title-row{font-size:0.3rem;width: 100%;text-align: left;font-weight: 600;padding: 0.3rem;}
.imgrow{display: flex;flex-flow: row;width: 100%;padding: 0 0.3rem;}
.imgcol{width:25%;display: flex;flex-flow: column nowrap;justify-content: center;font-size:0.25rem;}

.btnrow{display: flex;flex-flow: row;width: 100%;justify-content: center;align-items: center;padding: 0 0.3rem;margin-top: 0.25rem;}
.sumitbtn{width:100%;border-radius: 0.2rem;background-color: #ee0a24;color:#fff;font-size:0.38rem;height:1rem;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;}

::v-deep .van-uploader{display:flex ;justify-content: center;}
::v-deep .van-uploader__upload-icon{font-size:80px;}
::v-deep .van-uploader__upload{margin: 0;background-color: #fff;}
</style>


